import { createSlice } from "@reduxjs/toolkit";

export const nftSlice = createSlice({
  name: "nft",
  initialState: {
    nfts: [],            
    likedNfts: [],      
    currentPage: 1,       
    totalPages: 177,       
    perPage: 12,        
  },
  reducers: {
    setNFTs: (state, action) => {
      state.nfts = action.payload?.nfts || [];  
      state.totalPages = action.payload?.totalPages || state.totalPages;  
    },

    likeNFT: (state, action) => {
      const id = action.payload;
    
      if (!state.likedNfts.data?.includes(id)) {
        state.likedNfts.data = [...state.likedNfts?.data, id];  
      }
    },

    dislikeNFT: (state, action) => {
      const id = action.payload;
      state.likedNfts = state.likedNfts?.data?.filter((nftId) => nftId !== id); 
    },

    setLikedNFTs: (state, action) => {
      state.likedNfts = action.payload; 
      state.totalPages = action.payload?.totalPages || state.totalPages;  
    },

    clearNFTs: (state) => {
      state.nfts = []; 
    },

    setCurrentPage: (state, action) => {
      const page = action.payload;
      state.currentPage = typeof page === 'number' && page > 0 ? page : state.currentPage;  
    },
  },
});

export const { setNFTs, likeNFT, dislikeNFT, setLikedNFTs, clearNFTs, setCurrentPage } = nftSlice.actions;
export default nftSlice.reducer;
